import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import zipcodeApi from '~/clientApis/zipcodeApi';

const getExistingZipcode = async () => {
    const { zipcodeStore, electionMenuStore } = getStore();
    const { election } = electionMenuStore;

    if (!election?.id) {
        return;
    }

    zipcodeStore.setIsGettingZipcode(true);

    try {
        const existingZipcodeList = await zipcodeApi.getExistingZipcode(election?.id as string);
        zipcodeStore.setExistingZipcodeList(existingZipcodeList);
    } catch {
        showMessageModal('error', 'Error getting existing zipcode');
    } finally {
        zipcodeStore.setIsGettingZipcode(false);
    }
};

export default getExistingZipcode;
